package layout

import antd.MouseEvent
import antd.breadcrumb.BreadcrumbProps
import antd.breadcrumb.breadcrumb
import antd.breadcrumb.breadcrumbItem
import antd.divider.divider
import antd.dropdown.dropdown
import antd.icon.downOutlined
import antd.icon.menuFoldOutlined
import antd.icon.userOutlined
import antd.layout.*
import antd.layout.header
import antd.menu.menu
import antd.menu.menuItem
import antd.menu.subMenu
import antd.pageheader.pageHeader
import antd.spin.spin
import app.ActiveMenuPath
import app.Menu
import app.MenuPosition
import external.toJsObject
import kotlinext.js.js
import kotlinx.browser.window
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLDivElement
import react.*
import react.router.dom.useHistory
import user.service.AuthService
import react.dom.*
import react.router.dom.navLink
//import ui.component.display.ToastEvenType
//import ui.component.display.ToastEventDetailContent
import urlBase

external interface PageProps: RProps {
   var content:String
}

val defaultPrimaryMenu = Menu.首页

external interface PageHeaderProps: RProps {
    var backIcon: ReactElement?
    var prefixCls: String?
    var title: Any /* String | ReactElement */
    var subTitle: Any? /* String | ReactElement */
    var style: dynamic
    var breadcrumb: BreadcrumbProps?
    var tags: Any? /* ReactElement | Array<ReactElement> */
    var avatar: Any?
    var ghost: Boolean?
    var footer: Any? /* String | ReactElement */
    var extra: Any? /* String | ReactElement */
    var onBack: ((e: MouseEvent<HTMLDivElement>) -> Unit)?
    var className: String?
    var children: dynamic?
}

data class PageContextData(val headerProps: PageHeaderProps?, val setHeaderProps:(headerProps:PageHeaderProps?)->Unit, val collapsed:Boolean, val setCollapsed:(Boolean)->Unit);

val PageContext = createContext(PageContextData(null,{},false,{}))

fun RBuilder.page(classes:String, defaultActiveMenuPath: ActiveMenuPath, children: RBuilder.() -> Unit)  = div(classes) {
     child(functionalComponent<PageProps> { props->

         val history = useHistory()
         val (accessablePrimaryMenus,setAccessablePrimaryMenus) = useState(Menu.values()) //主菜单，暂时不采用基于权限确定可见与否

         val (activeMenuPath,setActiveMenuPath) = useState(defaultActiveMenuPath)
         val (selectedPrimaryMenu,setSelectedPrimaryMenu) = useState(defaultActiveMenuPath.primaryMenu ?:defaultPrimaryMenu)
         val (subMenus,setSubMenus) = useState(Menu.getAccessableSubMenuItems(selectedPrimaryMenu))

         val (headerProps,setHeaderProps) = useState<PageHeaderProps?>(null)
        // val (toastEventDetail,setToastEventDetail) = useState<ToastEventDetailContent>(ToastEventDetailContent(ToastEvenType.Hide))
         val (siderCollapsed,setSiderCollapsed) = useState(false)

         val userAuthData = AuthService.getUserAuthData()
         //val menus = Menus(accessablePrimaryMenus, subMenus,activeMenuPath)

         console.log(activeMenuPath,defaultActiveMenuPath)


         /**
          * 根据权限确定可看到哪些主菜单
          */
         /*fun setPrimaryMenusAccordingToLoa(){
             var accessablePrimaryMenus = arrayOf(defaultPrimaryMenu);
             if (memberAuthData != null) {
                 memberAuthData.loa?.let {loas->
                     loas.forEach{
                         try {
                             accessablePrimaryMenus += Menu.valueOf(it)
                         }catch (ex:Throwable){
                             //配置与本地设置不符
                         }
                     }

                 }
             }
             console.log("accessablePrimaryMenus",accessablePrimaryMenus)
             setAccessablePrimaryMenus(accessablePrimaryMenus)
         }*/

         fun onPrimaryMenuSelected(selectedMenu: Menu){
             console.log("onPrimaryMenuSelected",selectedMenu)
             selectedMenu.subMenus?.firstOrNull()?.let{ defaultOpened->
                 setActiveMenuPath(ActiveMenuPath(selectedMenu, defaultOpened.menu))
             }
         }

         useEffectOnce {
             if(AuthService.getUserAuthData() == null){//未登录
                 setAccessablePrimaryMenus(Menu.values().filter { it.loginOnly == false }.toTypedArray())
             }
         }

         useEffect(selectedPrimaryMenu) {
             if(defaultActiveMenuPath.primaryMenu != selectedPrimaryMenu) {
                 val link = selectedPrimaryMenu.linkTo?.toJsObject()?.link?.toJsObject()
                 console.log("onPrimaryMenuSelected", link?.url, history.location.pathname)
                 if (link != null && link.url != null && link.url != history.location.pathname) {
                     console.log("go to ${link.url}")
                     history.push(link.url)
                 } else {
                     setSubMenus(Menu.getAccessableSubMenuItems(selectedPrimaryMenu))
                 }
             }
         }

         useEffect(subMenus){
             if(defaultActiveMenuPath.primaryMenu != selectedPrimaryMenu) {
                 subMenus.firstOrNull()?.let { defaultOpened ->
                     console.log("defaultOpened", defaultOpened)
                     setActiveMenuPath(ActiveMenuPath(selectedPrimaryMenu, defaultOpened.menu))
                 }
             }
         }

         /*useEffectOnce {
             setPrimaryMenusAccordingToLoa()
         }*/

         PageContext.Provider(PageContextData(headerProps,
             { header_->setHeaderProps(header_) },siderCollapsed,
             { collapsed_->setSiderCollapsed(collapsed_) })) {

             val sidebarMenus = subMenus.filter { it.position == MenuPosition.LEFT }.toTypedArray()
             val topSecondaryMenus = subMenus.filter { it.position == MenuPosition.TOP }.toTypedArray()

        //////     console.log(subMenus,"topSecondaryMenus",topSecondaryMenus)

             div{
                 this.attrs{
                     jsStyle = js {
                         padding = "0"
                     }
                 }

                 layout {

                     header {
                         this.attrs { className = "page-header header" }

                         div("logo"){
                             this.attrs{
                                 jsStyle=js{
                                     float = "left"
                                 }
                             }
                             h2{
                                 attrs{
                                     jsStyle {
                                         color = "white"
                                     }
                                 }
                                 +"经方派　　"
                             }
                         }
                         menu {
                             this.attrs {
                                 theme = "dark"
                                 mode = "horizontal"
                                 defaultSelectedKeys = arrayOf(activeMenuPath.primaryMenu.name)
                             }
                             accessablePrimaryMenus.forEach { primaryMenu ->
                                 menuItem {
                                     attrs {
                                         key = primaryMenu.name
                                         onClick = { setSelectedPrimaryMenu(primaryMenu) }
                                     }
                                     +primaryMenu.name
                                 }
                             }
                         }
                         div {
                             this.attrs {
                                 jsStyle = js {
                                     position = "absolute"
                                     right = "60px"
                                     top = "0"
                                 }
                             }
                             if(userAuthData == null){
                                 navLink<RProps>(UserRoute.Login.link.url){
                                     +"登录"
                                 }
                             }else {
                                /* span {
                                     this.attrs {
                                         jsStyle = js {
                                             color = "white"
                                             paddingRight = "10px"
                                         }
                                     }
                                     +"${AuthService.getUserAuthData()?.organizationName ?: ""} ${AuthService.getUserAuthData()?.userName ?: ""}"
                                 }*/

                                 dropdown {
                                     attrs{
                                         overlay = buildElement{
                                             menu {
                                                 menuItem{
                                                     a{
                                                         attrs{
                                                             onClickFunction = {
                                                                 AuthService.removeAuthData()
                                                                 window.location.reload()
                                                             }
                                                         }
                                                         +"退出登录"
                                                     }
                                                 }
                                             }
                                         }
                                     }
                                     a{
                                         attrs{
                                             onClickFunction = {
                                                 event ->  event.preventDefault()
                                             }
                                         }
                                         span{
                                             userOutlined {  }
                                             span{
                                                 +"${AuthService.getUserAuthData()?.organizationName ?: ""} ${AuthService.getUserAuthData()?.userName ?: ""}"
                                             }
                                             downOutlined {  }
                                         }
                                     }

                                 }


                                 /*menu {
                                     attrs{
                                         theme = "dark"
                                         mode = "inline"
                                         onClick = { clicked ->
                                             when(clicked.key){
                                                 "signout" -> {
                                                     AuthService.removeAuthData()
                                                     window.location.reload()
                                                 }
                                             }
                                         }
                                     }
                                     subMenu {
                                         attrs{
                                             key = "user-menu"
                                             icon = buildElement {
                                                 userOutlined {  }
                                             }
                                             title = "${AuthService.getUserAuthData()?.organizationName ?: ""} ${AuthService.getUserAuthData()?.userName ?: ""}"
                                         }
                                         menuItem {
                                             attrs{
                                                 key = "signout"
                                             }
                                             +"退出登录"
                                         }
                                     }
                                 }*/
                             }

                         }
                     }
                     div {
                         this.attrs{
                             jsStyle = js{
                                 height= "2px"
                                 background= "#1d73d0"
                             }
                         }
                     }

                     if(topSecondaryMenus.size>0){
                         div{
                             attrs["id"] = "secondary-menu"
                             space {
                                 attrs{
                                     split = buildElement{
                                         divider {
                                             attrs{
                                                 type="vertical"
                                             }
                                         }
                                     }
                                 }
                                 topSecondaryMenus.forEach { secondaryMenu->
                                     secondaryMenu.items.forEach { secondaryMenuItem ->
                                         if(secondaryMenuItem.link.targetBlank?:false) {
                                             a{
                                                 attrs {
                                                     target = "_blank"
                                                     href = secondaryMenuItem.link.url
                                                     +secondaryMenuItem.link.text
                                                 }
                                             }
                                         }else{
                                             navLink<RProps>(secondaryMenuItem.link.url) {
                                                 +secondaryMenuItem.link.text
                                             }
                                         }
                                     }
                                 }

                             }
                         }
                     }

                     layout {
                         this.attrs {
                             hasSider = sidebarMenus.size>0
                             style = js {
                                 className = "page-layout-main"
                             }
                         }
                         if(sidebarMenus.size>0){
                            sider {
                             this.attrs {
                                 id = "sidebar"
                                 prefixCls = "page-sidebar"
                                 trigger = true
                                 style = js{
                                     maxWidth = "200px"
                                 }
                                 className = "page-layout-sidebar"
                                 collapsible=true
                                 collapsed=collapsed
                                 onCollapse={collapsed,type->setSiderCollapsed(collapsed)}
                             }
                             menu {
                                 this.attrs {
                                     mode = "inline"
                                     theme="dark"
                                     /*defaultOpenKeys =  //初始展开的 SubMenu 菜单项 key 数组
                                         if (activeMenuPath.subMenu != null) arrayOf(
                                             activeMenuPath.subMenu.getLiteral()
                                         ) else arrayOf()*/
                                     openKeys = if (activeMenuPath.subMenu != null) arrayOf(
                                         activeMenuPath.subMenu.getLiteral()
                                     ) else arrayOf()
                                     /*defaultSelectedKeys = //初始选中的菜单项 key 数组
                                         if (activeMenuPath.subMenuItemLink != null) arrayOf(
                                             activeMenuPath.subMenuItemLink.url
                                         ) else arrayOf()*/
                                     selectedKeys = //初始选中的菜单项 key 数组
                                         if (activeMenuPath.subMenuItemLink != null) arrayOf(
                                             activeMenuPath.subMenuItemLink.url
                                         ) else arrayOf()
                                     style = js{
                                         borderRight=0;
                                         height="auto" //${state.height}px
                                     }
                                 }
                                 subMenus.forEachIndexed {index,currentSubMenu->
                                     subMenu {
                                         if(currentSubMenu.menu !=null) {
                                             this.attrs {
                                                 icon = buildElement {
                                                     menuFoldOutlined {}
                                                 }
                                                 key = "${currentSubMenu.menu.getLiteral()}"
                                                 title = buildElement {
                                                     span { +currentSubMenu.menu.getLiteral() }
                                                 }
                                                 onTitleClick = {
                                                     setActiveMenuPath(ActiveMenuPath(selectedPrimaryMenu,currentSubMenu.menu))
                                                 }
                                             }
                                         }
                                         currentSubMenu.items.toJsObject().forEach { currentRoute->
                                             menuItem {
                                                 attrs {
                                                     key = currentRoute.link.url
                                                 }
                                                 if(currentRoute.link.targetBlank?:false) {
                                                     a{
                                                         attrs {
                                                             target = "_blank"
                                                             href = currentRoute.link.url
                                                             +currentRoute.link.text
                                                         }
                                                     }
                                                 }else{
                                                     navLink<RProps>(currentRoute.link.url) {
                                                         +currentRoute.link.text
                                                     }
                                                 }
                                             }
                                         }
                                     }
                                 }

                             }
                         }
                         }
                         layout {
                             this.attrs {
                                 style = js("{padding:\"0 24px 24px\";background:\"white\"}")
                             }
                             breadcrumb {
                                 this.attrs {
                                     separator = ":"
                                     style = js("{margin:'20px'}")
                                 }
                                 breadcrumbItem {
                                     +"位置"
                                 }

                                breadcrumbItem {
                                     +activeMenuPath.primaryMenu.name
                                 }

                                 activeMenuPath.subMenu?.let {
                                     breadcrumbItem {
                                         +it.getLiteral()
                                     }
                                 }

                                 activeMenuPath.subMenuItemLink?.let {
                                     breadcrumbItem {
                                         +it.text
                                     }
                                 }

                                 activeMenuPath.extraBreadcrumb?.let {
                                     breadcrumbItem {
                                         +it
                                     }
                                 }

                             }
                             if (headerProps != null) {
                                 pageHeader {
                                     this.attrs {
                                         title = headerProps.title
                                         subTitle = headerProps.subTitle
                                         avatar = headerProps.avatar
                                         ghost = headerProps.ghost
                                         tags = headerProps.tags
                                         extra = headerProps.extra
                                         footer = headerProps.footer
                                         onBack = headerProps.onBack
                                     }
                                     headerProps.children?.let { headerChildren->
                                         child(headerChildren)
                                     }
                                 }
                             }
                             content {
                                 attrs{
                                     id = "page-content"
                                 }
                                 spin {
                                     this.attrs {
                                         spinning = false;//toastEventDetail.type != ToastEvenType.Hide
                                         wrapperClassName = "toast-wrapper"
                                        // tip = toastEventDetail?.content
                                     }
                                     children()
                                 }
                             }
                         }
                     }
                 }


             }

         }
     })
}
